import React, { ReactNode, useEffect, useState } from "react";

import { Sheet, Stack, Table, Theme } from "@mui/joy";

import { downloadTableAsCsv, getTableContentsAsTabularText } from "../util/dataUtil";
import TableInformationRow from "./TableInformationRow";
import { getTableDimensions } from "../util/elementUtil";
import { copyToClipboardOrShowAlert } from "../util/objectUtil";
import { AnalyticsEvents, analyticsEvent } from "../util/analytics";

interface PrimeTableProps {
    children?: ReactNode | undefined;
    showDownloadCopy: boolean;
}

const styles = {
    topContainer: (theme: Theme) => ({
        border: "1px solid",
        borderColor: "neutral.outlinedBorder",
        borderRadius: theme.radius.sm,
    }),
    actualTableObject: { marginBottom: 4, borderTop: 0 },
};

export default function PrimeTable(props: PrimeTableProps) {
    const [numberOfRows, setNumberOfRows] = useState<number | undefined>();

    useEffect(() => {
        const { rows } = getTableDimensions(props);
        setNumberOfRows(rows);
    }, [props]);

    // ID used for downloading
    const dataTableId = `table-${crypto.randomUUID()}`;

    const handleDownloadClick = () => {
        analyticsEvent(AnalyticsEvents.DOWNLOAD_TABLE);
        downloadTableAsCsv(dataTableId);
    };

    const handleCopyClick = () => {
        analyticsEvent(AnalyticsEvents.COPY_TABLE);
        const tabular = getTableContentsAsTabularText(dataTableId);
        if (tabular) {
            copyToClipboardOrShowAlert(tabular);
        }
    };

    return (
        <Stack sx={styles.topContainer}>
            <TableInformationRow
                showDownloadCopy={props.showDownloadCopy}
                onDownloadClick={handleDownloadClick}
                onCopyClick={handleCopyClick}
                numberOfRows={numberOfRows}
            />
            <Sheet>
                <Table sx={styles.actualTableObject} data-table-id={dataTableId}>
                    {props.children}
                </Table>
            </Sheet>
        </Stack>
    );
}
